var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copylink"},[_c('v-text-field',{ref:"input",attrs:{"filled":"","label":_vm.label,"disabled":_vm.disabled,"append-icon":"mdi-content-copy"},on:{"click:append":_vm.copyToClipboard},model:{value:(_vm.linkData),callback:function ($$v) {_vm.linkData=$$v},expression:"linkData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }